import { NotificationApi } from '@agilelab/plugin-wb-notification-common';
import { createApiRef } from '@mainstage/core-plugin-api';

export const notificationApiRef = createApiRef<NotificationApi>({
  id: 'wb-notification',
});
